import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_80: FaireProductEntity = {
  token: "catalog_prod_prod-80",
  type: "product",
  name: "Storage Container",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 108.26,
  msrpDollars: 270.65,
  sku: "AN0080",
  caseSize: 2,
  material: "Linen",
  collectionToken: "col_andean-touch",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: false,
  stockLevel: 144,
  description: "Beautiful Andean Touch piece perfect for any home.",
  categoryTokens: ["catalog_cat_crafts-hobbies"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
